export default __webpack_public_path__ + "static/award-banner-15c7d66901b514af58b4fe89574dbddb.png";